// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PReloadTimeOutlinedSvg from "@fishx/icons-svg/es/asn/PReloadTimeOutlined";
import FishxIcon from '../components/FishxIcon';

var PReloadTimeOutlined = function PReloadTimeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PReloadTimeOutlinedSvg
  }));
};

PReloadTimeOutlined.displayName = 'PReloadTimeOutlined';
export default React.forwardRef(PReloadTimeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PReloadTimeOutlined.js
// module id = 3594
// module chunks = 0